import { render, staticRenderFns } from "./MinisitePaylinkConfirmation.vue?vue&type=template&id=f342afa2&"
import script from "./MinisitePaylinkConfirmation.vue?vue&type=script&lang=js&"
export * from "./MinisitePaylinkConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f342afa2')) {
      api.createRecord('f342afa2', component.options)
    } else {
      api.reload('f342afa2', component.options)
    }
    module.hot.accept("./MinisitePaylinkConfirmation.vue?vue&type=template&id=f342afa2&", function () {
      api.rerender('f342afa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisitePaylinkConfirmation.vue"
export default component.exports